import React from 'react';
import Portfolio from '../components/Portfolio';
import notFound from '../content/notFound';

export default () => <Portfolio portfolio={notFound} />;
